module.exports = __webpack_public_path__ + "static/media/arrow-down.7a03fe2e.svg";